import { FC } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { Box, BoxProps, Link, MenuList, CSSObject, Flex, LinkProps, AccordionIcon } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rgba } from 'polished';

const activeClassName = 'link-active';

export const DropdownMenuLink: FC<LinkProps & NavLinkProps> = ({ children, ...props }) => (
  <Link
    as={NavLink}
    exact
    activeClassName={activeClassName}
    d="flex"
    w="100%"
    position="relative"
    _hover={{ textDecoration: 'none' }}
    sx={{
      [`&.${activeClassName}`]: {
        fontWeight: 500,
        color: 'primary.500',
        padding: '0 8px',
        _before: {
          content: '""',
          position: 'absolute',
          borderRadius: '4px',
          transition: 'all 0.2s ease-in-out',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: 'calc(100% + 16px)',
          bgColor: 'backgrounds.primary',
        },
      },
    }}
    {...props}
  >
    <Flex w="100%" justifyContent="space-between" alignItems="center" zIndex="1">
      {children}
    </Flex>
  </Link>
);

export const StyledMenuList = styled(MenuList)`
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
`;

export const ListItemsWrapper: FC<BoxProps> = ({ children, ...props }) => (
  <Box bgColor="white" borderRadius="12px" p="20px 24px" boxShadow={`0 4px 10px ${rgba('black', 0.1)}`} {...props}>
    {children}
  </Box>
);

export const setOverlayStyles = (isOpen: boolean): CSSObject => ({
  content: '""',
  position: 'fixed',
  left: 0,
  top: 0,
  width: isOpen ? '100%' : '0',
  height: isOpen ? '100%' : '0',
  bgColor: 'black',
  transition: 'opacity 0.2s',
  zIndex: '1000',
});

export const StyledAccordionIcon = styled(AccordionIcon)<{ iconColor: string }>`
  path {
    fill: ${({ iconColor }) => iconColor};
  }
`;

export const MobileListItem = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: 15px 24px;
  &:first-child {
    margin-top: 20px;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;
